export default {
	SET_NAVIGATION_TREE: 'SET_NAVIGATION',
	SET_NAVIGATION_DATA: 'SET_NAVIGATION_DATA',
	SET_SEARCH_FILTER: 'SET_SEARCH_FILTER',
	FILTER_NAVIGATION: 'FILTER_NAVIGATION',
	UPDATE_NAVIGATION_ITEM: 'UPDATE_NAVIGATION_ITEM',
	HIDE_ALL_SUBMENU: 'HIDE_ALL_SUBMENU',
	SHOW_NAVIGATION_NODE: 'SHOW_NAVIGATION_NODE'
};
